import React from "react";
import { Box, BoxProps, TableCell } from "@material-ui/core";
import { ColumnHeading } from "../Table";

export interface HeadProps {
  boxProps?: BoxProps;
}

export const ColumnHead: React.FC<HeadProps> = ({ children, boxProps }) => {
  return (
    <Box component={TableCell} height={49} {...boxProps}>
      <Box textAlign={boxProps?.textAlign}>
        <ColumnHeading>{children}</ColumnHeading>
      </Box>
    </Box>
  );
};
